@if (isMobile) {
    <section class="mobile">
        <div class="info">
            <app-checkbox [text]="text" [checked]="checked" [isDisabled]="isDisabled" />

            @if (date && name) {
                <div class="wrapper">
                    <span>{{ name }}</span>

                    <span>{{ date | date }}</span>
                </div>
            }
        </div>

        <app-svg-icon icon="ellipsis" />
    </section>
} @else {
    <section class="task-container" [class.disabled]="isDisabled">
        <app-checkbox [text]="text" [checked]="checked" [isDisabled]="isDisabled" />

        @if (date && name) {
            <div class="info">
                <div class="wrapper">
                    <img [src]="avatar" priority [width]="32" [height]="32" alt="avatar" />

                    <span>{{ name }}</span>
                </div>

                <span class="wrapper">{{ date | date }}</span>

                <span class="wrapper">
                    <app-svg-icon icon="ellipsis" />
                </span>
            </div>
        }
    </section>
}
